import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import logo from "./image.png";
import "./Navbar.css";

const SEARCH_MAP = {
  home: { path: "/", id: "home" },
  approach: { path: "/", id: "approach" },
  technical: { path: "/", id: "technical-framework" },

  about: { path: "/about", id: "about" },

  contact: { path: "/contact", id: "contact" },
  email: { path: "/contact", id: "contact" },
  phone: { path: "/contact", id: "contact" },
};

function Navbar() {
  const [showSearch, setShowSearch] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [query, setQuery] = useState("");

  const navigate = useNavigate();

  const handleSearch = (e) => {
    if (e.key !== "Enter") return;

    const keyword = query.toLowerCase().trim();
    if (!keyword) return;

    const match = Object.keys(SEARCH_MAP).find((key) =>
      keyword.includes(key)
    );

    if (!match) {
      alert("No matching section found");
      return;
    }

    const { path, id } = SEARCH_MAP[match];

    navigate(path);

    // ⏳ Wait for route render then scroll
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 300);

    setShowSearch(false);
    setQuery("");
  };

  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark fixed-top"
      style={{
        backgroundColor: "#416caeff",
        minHeight: "64px",
        zIndex: 9999,
      }}
    >
      <div className="container-fluid px-3 position-relative">
        {/* TOP ROW */}
        <div
          className={`d-flex align-items-center w-100 transition ${
            showSearch ? "nav-hidden" : "nav-visible"
          }`}
        >
          <Link
            className="navbar-brand d-flex align-items-center gap-2"
            to="/"
            onClick={() => setMenuOpen(false)}
          >
            <img src={logo} alt="SEA'S 2050" width="38" height="38" />
            <span className="brand-text">SEA'S 2050</span>
          </Link>

          {/* HAMBURGER */}
          <button
            className="navbar-toggler ms-auto"
            onClick={() => setMenuOpen((p) => !p)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* SEARCH ICON (DESKTOP) */}
          <div className="d-none d-lg-flex ms-3">
            <button
              className="btn btn-outline-light btn-sm"
              onClick={() => setShowSearch(true)}
            >
              <i className="bi bi-search"></i>
            </button>
          </div>
        </div>

        {/* MENU */}
        <div className={`collapse navbar-collapse ${menuOpen ? "show" : ""}`}>
          <ul className="navbar-nav ms-lg-auto gap-lg-3 text-center mt-3 mt-lg-0" style={{fontSize: 'larger', fontWeight: '700'}}>
            <li className="nav-item">
              <NavLink className="nav-link" to="/" onClick={() => setMenuOpen(false)}>
                Home
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/about" onClick={() => setMenuOpen(false)}>
                About
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/contact" onClick={() => setMenuOpen(false)}>
                Contact
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/data" onClick={() => setMenuOpen(false)}>
                Data
              </NavLink>
            </li>

            {/* MOBILE SEARCH */}
            <li className="nav-item d-lg-none mt-3">
              <button
                className="btn btn-outline-light w-100"
                onClick={() => {
                  setShowSearch(true);
                  setMenuOpen(false);
                }}
              >
                <i className="bi bi-search me-2"></i> Search
              </button>
            </li>
          </ul>
        </div>

        {/* SEARCH OVERLAY */}
        <div
          className={`search-overlay transition ${
            showSearch ? "search-visible" : "search-hidden"
          }`}
        >
          <input
            type="text"
            className="form-control form-control-lg"
            placeholder="Search keywords..."
            value={query}
            autoFocus
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={handleSearch}
          />

          <button
            className="btn btn-link text-white ms-3"
            onClick={() => setShowSearch(false)}
          >
            <i className="bi bi-x-lg fs-4"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
